import { Toaster } from 'react-hot-toast';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { ChildrenProps, toasterOptions } from '@dfl/mui-react-common';
import { useSettings } from 'contexts/SettingsProvider';
import QueryProvider from 'contexts/QueryContext';
import { AuthControl, SecurityProvider, useUser } from '@dfl/react-security';
import { useNotificationSocket } from 'modules/notification/hooks/useNotificationSocket';
import { useForegroundPushNotifications } from 'modules/notification/hooks/useForegroundPushNotifications';
import { SocketProvider } from 'contexts/SocketProvider';
import { ExportModalProvider } from 'contexts/ExportModalProvider';
import { CentralizedExportProvider } from 'contexts/CentralizedExportProvider';
import { CurrencyProvider } from './CurrencyProvider';
// import { TourProviderCustom as TourProvider } from './TourProvider';

type AppContentProps = {
  children: any;
};

const AppContent = ({ children }: AppContentProps) => {
  // Global notification socket - always mounted
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  useNotificationSocket();
  // App-wide FCM foreground listener - shows notifications when the tab is open but not focused
  useForegroundPushNotifications();

  return (
    <>
      <AuthControl />
      {children}

      <CssBaseline />
      <Toaster
        toastOptions={{
          ...toasterOptions,
          custom: {
            duration: 4000,
          },
        }}
        containerStyle={{ top: 80 }}
      />
    </>
  );
};

export const AppProvider = ({ children }: ChildrenProps) => {
  const { theme } = useSettings(); // App theme
  const { user } = useUser();

  return (
    <QueryProvider>
      <ThemeProvider theme={theme}>
        {/*   <TourProvider> */}
        <SecurityProvider useMe={user}>
          <CurrencyProvider>
            <SocketProvider>
              <CentralizedExportProvider>
                <ExportModalProvider>
                  <AppContent>{children}</AppContent>
                </ExportModalProvider>
              </CentralizedExportProvider>
            </SocketProvider>
          </CurrencyProvider>
        </SecurityProvider>
        {/* </TourProvider> */}
      </ThemeProvider>
    </QueryProvider>
  );
};
